import { ContractorForm } from '../forms/ContractorForm';

const ContractorFormDrawer = ({ handleCloseDrawer, selected, isEditing, contractorsState, onlyVisual }: any) => {
    
    return (
        <ContractorForm
            handleCloseDrawer={handleCloseDrawer}
            selected={selected}
            isEditing={isEditing}
            contractorsState={contractorsState}
            onlyVisual={onlyVisual}
        />
    );
};

export { ContractorFormDrawer };
